angular.module('mercury.services.payroll', [])
.factory('PayrollPayType', ["$resource", "$http", "settings", function($resource, $http, settings) {

  var allPayTypes = $resource(settings.mercHost + '/payroll/pay-type');
  var deletePayTypes = $resource(settings.mercHost + '/payroll/pay-type/:payTypeRef', {payTypeRef: '@payTypeRef'}, {'delete': {method: 'DELETE'}});
  var certainPayrollPayTypes = $resource(settings.mercHost + '/payroll/pay-type/:payrollSystem', {payrollSystem: '@payrollSystem'});
  var defaultPayTypes = $resource(settings.mercHost + '/payroll/pay-type/default');

  /**
   * Gets all pay types (default and custom)
   * @param {*} companyId, (optional) the company id of the company the payroll pay type to be added to. If not included defaults to the active company
   * @returns promise of the GET request
   */
  function getAllPayTypes(companyId) {

    // If company Id is included get data from that company rather than the users currently active one
    if (companyId) {
      return $http.get(settings.mercHost + '/payroll/pay-type', {headers: {'x-loaded-company-id': companyId}, params: {isArray: 'true'}})
      .then(function(response) {
        return response.data;
      });
    }

    return allPayTypes.query().$promise;
  }

  /**
   * Gets all pay types from a certain payroll system and all custom pay types
   * @param {*} payrollSystem, the payroll system of the wanted payroll pay types
   * @param {*} companyId, (optional) the company id of the company the payroll pay type to be added to. If not included defaults to the active company
   * @returns promise of the GET request
   */
  function getPayrollSystemPayTypes(payrollSystem, companyId) {

    // If company Id is included get data from that company rather than the users currently active one
    if (companyId) {
      $http.get(settings.mercHost + '/payroll/pay-type/' + payrollSystem, {headers: {'x-loaded-company-id': companyId}})
      .then(function(response) {
        return response.data;
      });
    }

    return certainPayrollPayTypes.get(payrollSystem).$promise;
  }

  /**
   * Gets all default pay types
   */
  function getAllDefaultPayTypes() {
    return defaultPayTypes.query().$promise;
  }

  /**
   * Deletes a given pay type
   * @param {*} payTypeRef, the payroll pay type reference
   * @param {*} companyId, (optional) the company id of the company the payroll pay type to be added to. If not included defaults to the active company
   * @returns promise of the DELETE request
   */
  function removePayType(payTypeRef, companyId) {

    // If company Id is included get data from that company rather than the users currently active one
    if (companyId) {
      return $http.delete(settings.mercHost + '/payroll/pay-type/' + payTypeRef, {headers: {'x-loaded-company-id': companyId}})
      .then(function(response) {
        return response.data;
      });
    }

    return deletePayTypes.delete({payTypeRef: payTypeRef}).$promise;
  }

  /**
   * Puts a given payroll pay type
   * @param {*} payType, the pay type to be updated
   * @param {*} companyId, (optional) the company id of the company the payroll pay type to be added to. If not included defaults to the active company
   * @returns promise of the PUT request
   */
  function editPayType(payType, companyId) {
    var putModel = {
      'payTypeRef': payType.payTypeRef,
      'payrollSystem': payType.payrollSystem,
      'payType': payType.payType,
      'payCode': payType.payCode,
      'deletedAt': payType.deletedAt
    };

    // If company Id is included get data from that company rather than the users currently active one
    if (companyId) {
      return $http.put(settings.mercHost + '/payroll/pay-type', putModel, {headers: {'x-loaded-company-id': companyId}})
      .then(function(response) {
        return response.data;
      });
    }

    return allPayTypes.update(putModel).$promise;
  }

  /**
   * Posts a new payroll pay type
   * @param {*} payType, the value fo the pay type to be created
   * @param {*} payCode, the value of the pay code to be created
   * @param {*} companyId, (optional) the company id of the company the payroll pay type to be added to. If not included defaults to the active company
   * @returns promise of the POST request
   */
  function addPayType(payType, payCode, companyId) {
    var postModel = {
      'payType': payType,
      'payCode': payCode
    };

    // If company Id is included get data from that company rather than the users currently active one
    if (companyId) {
      return $http.post(settings.mercHost + '/payroll/pay-type', postModel, {headers: {'x-loaded-company-id': companyId}})
      .then(function(response) {
        return response.data;
      });
    }

    return allPayTypes.save(postModel).$promise;
  }

  return {
    getAllPayTypes: getAllPayTypes,
    getPayrollSystemPayTypes: getPayrollSystemPayTypes,
    getAllDefaultPayTypes: getAllDefaultPayTypes,
    addPayType: addPayType,
    editPayType: editPayType,
    removePayType: removePayType
  };
}]);
